import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

// Api
import { getListLessors } from 'api/lessor'

// Use
import useMounted from 'use/mounted'

// Components
import Select from 'ui/Form/Select'

export const SelectLessor = ({ name, value, onChange, ...props }) => {
  const isMounted = useMounted()
  const [loading, setLoading] = useState(false)
  const [options, setOptions] = useState(null)

  useEffect(() => {
    setLoading(true)

    getListLessors()
      .then((data) => {
        if (isMounted.current) {
          setOptions(data)
        }
      })
      .catch(() => {})
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [isMounted])

  useEffect(() => {
    if (options && options.length === 1 && value !== options[0].value) {
      onChange(options[0].value, name, options[0].label)
    }
  }, [options, onChange, value, name])

  const onSelectChange = (e) => {
    const selected = options.find((x) => x.value === e)
    onChange(e, name, selected ? selected.label : '')
  }

  return (
    <Select
      name={name}
      value={value}
      loading={loading}
      label="Lessor name"
      placeholder="Select here"
      options={options || []}
      disabled={!options || options.length <= 1}
      onChange={(e) => onSelectChange(e)}
      {...props}
    />
  )
}

SelectLessor.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
}

SelectLessor.defaultProps = {
  name: '',
  value: '',
  onChange: () => {},
}

export default SelectLessor
